import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  BusinessStatusOptions,
  BusinessStatusResponse,
  CreateDeliveryApplicationErrors,
  CreateDeliveryOptions,
  CreateDeliveryResponse,
  EstimateDeliveryApplicationErrors,
  EstimateDeliveryOptions,
  EstimateDeliveryResponse,
  ListAccountIdsResponse,
  businessStatus as universalBusinessStatus,
  createDelivery as universalCreateDelivery,
  estimateDelivery as universalEstimateDelivery,
  listAccountIds as universalListAccountIds,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/restaurants' };

export function listAccountIds(
  httpClient: HttpClient
): ListAccountIdsSignature {
  return (instanceId: string) =>
    universalListAccountIds(
      instanceId,
      // @ts-ignore
      { httpClient }
    );
}

interface ListAccountIdsSignature {
  /**
   * Retrieves list of account belongs to given instance
   * @param - Instance ID.
   */
  (instanceId: string): Promise<
    NonNullablePaths<ListAccountIdsResponse, `accountIds`, 2>
  >;
}

export function businessStatus(
  httpClient: HttpClient
): BusinessStatusSignature {
  return (
    instanceId: string,
    options: NonNullablePaths<BusinessStatusOptions, `accountId`, 2>
  ) =>
    universalBusinessStatus(
      instanceId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BusinessStatusSignature {
  /**
   * Retrieves the delivery vendor business status
   * @param - Instance ID.
   */
  (
    instanceId: string,
    options: NonNullablePaths<BusinessStatusOptions, `accountId`, 2>
  ): Promise<NonNullablePaths<BusinessStatusResponse, `status`, 2>>;
}

export function estimateDelivery(
  httpClient: HttpClient
): EstimateDeliverySignature {
  return (
    instanceId: string,
    options?: NonNullablePaths<
      EstimateDeliveryOptions,
      `accountId` | `orderTotal` | `storeLocationId`,
      2
    >
  ) =>
    universalEstimateDelivery(
      instanceId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface EstimateDeliverySignature {
  /**
   * Retrieves an estimate of the delivery
   * @param - Instance ID.
   */
  (
    instanceId: string,
    options?: NonNullablePaths<
      EstimateDeliveryOptions,
      `accountId` | `orderTotal` | `storeLocationId`,
      2
    >
  ): Promise<
    NonNullablePaths<
      EstimateDeliveryResponse,
      `fee.value` | `fee.currency`,
      3
    > & {
      __applicationErrorsType?: EstimateDeliveryApplicationErrors;
    }
  >;
}

export function createDelivery(
  httpClient: HttpClient
): CreateDeliverySignature {
  return (
    instanceId: string,
    options?: NonNullablePaths<
      CreateDeliveryOptions,
      | `accountId`
      | `customer`
      | `customer.email`
      | `customer.firstName`
      | `customer.lastName`
      | `customer.phoneNumber`
      | `dropoffAddress`
      | `orderId`
      | `orderTip`
      | `orderTotal`
      | `pickupAddress`
      | `pickupBusinessName`
      | `pickupPhoneNumber`
      | `storeLocationId`,
      3
    >
  ) =>
    universalCreateDelivery(
      instanceId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateDeliverySignature {
  /**
   * Creates a new delivery order
   * @param - Instance ID.
   */
  (
    instanceId: string,
    options?: NonNullablePaths<
      CreateDeliveryOptions,
      | `accountId`
      | `customer`
      | `customer.email`
      | `customer.firstName`
      | `customer.lastName`
      | `customer.phoneNumber`
      | `dropoffAddress`
      | `orderId`
      | `orderTip`
      | `orderTotal`
      | `pickupAddress`
      | `pickupBusinessName`
      | `pickupPhoneNumber`
      | `storeLocationId`,
      3
    >
  ): Promise<
    NonNullablePaths<
      CreateDeliveryResponse,
      `_id` | `fee.value` | `fee.currency`,
      3
    > & {
      __applicationErrorsType?: CreateDeliveryApplicationErrors;
    }
  >;
}

export {
  Address,
  AddressLocation,
  BusinessStatus,
  BusinessStatusOptions,
  BusinessStatusRequest,
  BusinessStatusResponse,
  CreateDeliveryOptions,
  CreateDeliveryOptionsDispatchTimeOneOf,
  CreateDeliveryRequest,
  CreateDeliveryRequestDispatchTimeOneOf,
  CreateDeliveryResponse,
  Customer,
  EstimateDeliveryOptions,
  EstimateDeliveryOptionsDispatchTimeOneOf,
  EstimateDeliveryRequest,
  EstimateDeliveryRequestDispatchTimeOneOf,
  EstimateDeliveryResponse,
  ListAccountIdsRequest,
  ListAccountIdsResponse,
  Money,
  StreetAddress,
  Tpa,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';
